
export default function PrivacyPage() {

  return (
    <div>
    <h2>Datenschutzerklärung für das Gewinnspiel von Asia Zushi Grill</h2>
    <p>Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Nachfolgend informieren wir Sie über die Verarbeitung Ihrer Daten im Rahmen der Teilnahme am Gewinnspiel gemäß der Datenschutz-Grundverordnung (DSGVO).</p>

    <h3>1. Verantwortlicher</h3>
    <p><strong>Asia Zushi Grill</strong><br />
    <a href="https://asiazushigrill.de">https://asiazushigrill.de</a></p>

    <h3>2. Zwecke der Datenverarbeitung</h3>
    <ul>
      <li>Durchführung des Gewinnspiels (z. B. Auslosung und Benachrichtigung der Gewinner)</li>
      <li>Versand von Angeboten, Werbeaktionen und Informationen zu Asia Zushi Grill per E-Mail oder Telefon</li>
    </ul>

    <h3>3. Rechtsgrundlage</h3>
    <p>Die Verarbeitung Ihrer Daten erfolgt gemäß Art. 6 Abs. 1 lit. a DSGVO auf Grundlage Ihrer freiwillig erteilten Einwilligung.</p>

    <h3>4. Empfänger der Daten</h3>
    <p>Die Verarbeitung erfolgt ausschließlich durch autorisierte Mitarbeiter:innen. Eine Weitergabe an Dritte findet nicht statt, es sei denn, dies ist für die Durchführung des Gewinnspiels erforderlich oder gesetzlich vorgeschrieben.</p>

    <h3>5. Speicherdauer</h3>
    <p>Ihre Daten werden nur so lange gespeichert, wie es für die Durchführung des Gewinnspiels und für Marketingzwecke erforderlich ist oder bis Sie Ihre Einwilligung widerrufen.</p>

    <h3>6. Ihre Rechte</h3>
    <p>Sie haben das Recht auf:</p>
    <ul>
      <li>Auskunft über Ihre gespeicherten Daten</li>
      <li>Berichtigung unrichtiger Daten</li>
      <li>Löschung Ihrer Daten</li>
      <li>Einschränkung der Verarbeitung</li>
      <li>Widerspruch gegen die Verarbeitung zu Werbezwecken</li>
      <li>Widerruf Ihrer Einwilligung mit Wirkung für die Zukunft</li>
    </ul>
    <p>Bitte wenden Sie sich dazu an die unter Punkt 1 genannte Stelle.</p>

    <h3>7. Weitere Informationen</h3>
    <p>Ergänzende Informationen zum Datenschutz finden Sie in unserer allgemeinen Datenschutzerklärung:<br />
    <a href="https://asiazushigrill.de/privacy-policy/">https://asiazushigrill.de/privacy-policy/</a></p>
  </div>
  );
}